
import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';

type ItemType = {[key: string]: unknown};

@Component
export default class SelectObject extends Vue {
  @Prop({default: [], type: Array})
  items!: ItemType[];

  d_items: ItemType[] = [];

  @Model('change', {required: false, type: Object, default: null})
  value!: ItemType | null;

  d_value: unknown = null;

  // The name of the field used to uniquely identify the items.
  @Prop({type: String})
  id_field!: string;

  @Watch('items')
  on_items_changed(new_items: ItemType[], old_items: ItemType[]) {
    this.d_items = new_items;
  }

  @Watch('value')
  on_value_changed(new_value: ItemType | null, old_value: ItemType | null) {
    this.set_d_value(new_value);
  }

  created() {
    this.d_items = this.items;
    this.set_d_value(this.value);
  }

  private set_d_value(value: ItemType | null) {
    if (value === null) {
      this.d_value = null;
    }
    else {
      this.d_value = value[this.id_field];
    }
  }

  private update_value() {
    let selected = this.d_items.find(
      (item) => item[this.id_field] === this.d_value);
    this.$emit('change', selected);
  }
}
